import React, { useEffect, useState } from "react";
import { Plus } from "../shared/icon";
import Dialog from "../shared/Dialog";
import ShareDialog from "./ShareDialog";
import axiosInstance from "../api/axiosInstance";
import { isAuthenticated } from "../utils/auth";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserListTab = () => {
  const navigate = useNavigate();
  const [shareDialog, setShareDialog] = useState(false);
  const [users, setUsers] = useState([]);

  const isLoggedIn = typeof window !== "undefined" ? isAuthenticated() : false;
  const canAccess = isLoggedIn 

  useEffect(() => {
    if (!isLoggedIn) return;

    let mounted = true;
    const fetchUsers = async () => {
      try {
        const payload = {
          limit: 100,
          page: 1,
        };

        const res = await axiosInstance.post(
          "/report/getAffUsersList",
          payload,
        );

        const list = Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.data?.response)
              ? res.data.response
              : [];

        if (!mounted) return;
        setUsers(list);
      } catch {
        if (!mounted) return;
        setUsers([]);
      }
    };

    fetchUsers();
    return () => {
      mounted = false;
    };
  }, [isLoggedIn]);

  return (
    <>
      <div className="af-table-wrapper">
        <table className="af-table default-table">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Balance</th>
              <th>Created Date Time</th>
              <th>Statement</th>
              <th>PL</th>
            </tr>
          </thead>

          <tbody id="userTableBody">
            {users.length === 0 ? (
              <tr>
                <td colSpan={5} className="no-records">
                  No Records Found
                </td>
              </tr>
            ) : (
              users.map((user, index) => (
                <tr key={index}>
                  <td>{user.user_name || user.name || user.username || "-"}</td>
                  <td>{user.balance ?? 0}</td>
                  <td>
                    {user.createdAt
                      ? new Date(user.createdAt).toLocaleString()
                      : "-"}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-thmemes"
                      onClick={() => {
                        if (!isLoggedIn) return;
                        if (!user?._id) return;
                        navigate(`/reports/account-statement?userId=${user._id}`);
                      }}
                    >
                      View
                    </button>
                  </td>
                  <td className={user.pl >= 0 ? "pl-positive" : "pl-negative"}>
                    <span
                      style={{ cursor: isLoggedIn ? "pointer" : "default" }}
                      className="btn btn-thmemes"
                      onClick={() => {
                        if (!isLoggedIn) return;
                        if (!user?._id) return;
                        navigate(`/reports/profit-loss?userId=${user._id}`);
                      }}
                    >
                      Veiw
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <button
        className="primary-btn d-block mt-3 w-100"
        onClick={() => {
          if (!canAccess) return;
          setShareDialog(true);
        }}
        disabled={!canAccess}
      >
        <Plus className="me-2" />
        ADD NEW USER
      </button>
      <Dialog
        show={shareDialog}
        onHide={() => setShareDialog(false)}
        centered
        animation={false}
        dialogClassName="bonus-dialog"
        contentClassName="mat-dialog-container"
      >
        <ShareDialog onClose={() => setShareDialog(false)} />
      </Dialog>
    </>
  );
};

export default UserListTab;
